import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  TacacsSettingUrl: '/api/sm/auth/tacacs-cm', // TACACS 설정 URL
  TacacsSyncUrl: '/api/sm/auth/tacacs-cm/sync', // TACACS 사용여부 설정 URL
  TacacsUrl: '/api/sm/auth', // TACACS URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // TACACS 조회 리스트

  // tacacsdServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {} // 수정중인 항목 모든탭 동일
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // TACACS 조회 리스트
    state.selectedStoreItem = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // TACACS 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_tacacs_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_tacacs_cm_id === data.authsvr_tacacs_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_tacacs_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_tacacs_cm_id: p.authsvr_tacacs_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getTacacsDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addTacacsData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editTacacsData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_tacacs_id: item.authsvr_tacacs_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delTacacsDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_tacacs_id: p.authsvr_tacacs_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.TacacsSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 통합 설정 추가
    try {
      const data = await this.$axios.$put(state.TacacsSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.TacacsSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_tacacs_cm_id': item.authsvr_tacacs_cm_id})
      delList.push(item.authsvr_tacacs_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.TacacsSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.TacacsSettingUrl}/${payload[0].authsvr_tacacs_cm_id}`)

      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.TacacsSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.TacacsSyncUrl}/${payload[0].authsvr_tacacs_cm_id}`, _.pick(payload[0], ['authsvr_tacacs_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.TacacsSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getTacacsDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.TacacsUrl}/${state.defaultId}/tacacs`)
      return resultFactory(commit, {length: null, data: data, action: 'getTacacsDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addTacacsData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload))
    try {
      const data = await this.$axios.$post(`${state.TacacsUrl}/${state.defaultId}/tacacs`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addTacacsData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editTacacsData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload))
    try {
      const data = await this.$axios.$put(`${state.TacacsUrl}/${state.defaultId}/tacacs/${payload.authsvr_tacacs_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editTacacsData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delTacacsDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_tacacs_id': item.authsvr_tacacs_id})
      delList.push(item.authsvr_tacacs_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.TacacsUrl}/${state.defaultId}/tacacs`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.TacacsUrl}/${state.defaultId}/tacacs/${payload[0].authsvr_tacacs_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delTacacsDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param) {
  const serverKeyMap = {
    name: 'tacacs_svr_name',
    ip: 'tacacs_svr_ip',
    passwd: 'tacacs_svr_passwd',
    port: 'tacacs_svr_port',
    tacacs_svr_id: 'tacacs_svr_id'
  }
  const server = []
  _.forEach(param.servers, (item) => {
    server.push(_.omit(_.mapKeys(item, (value, key) => {
      return serverKeyMap[key]
    }), ['undefined', 'itemIndex']))
  })
  param.servers = server

  const payloadKeyMap = {
    authsvr_tacacs_id: 'authsvr_tacacs_id',
    name: 'authsvr_tacacs_name',
    auth_type: 'authsvr_tacacs_auth_type',
    auth_only: 'authsvr_tacacs_auth_only',
    desc: 'authsvr_tacacs_desc',
    tm_out: 'authsvr_tacacs_tm_out',
    retry_cnt: 'authsvr_tacacs_retry_cnt',
    servers: 'servers'
  }
  return _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])
}
